import { createSelector } from 'reselect';

import { getDefaultAddressUseCase } from '@core/reducers/cities/models/City';
import { getCountryShortName } from '@shared/selectors';
import getSelectedCity from './getSelectedCity';

const getSelectedCityAddressUseCase = createSelector(
  getSelectedCity,
  getCountryShortName,
  (city, country) =>
    getDefaultAddressUseCase({ country, addressUseCase: city?.addressUseCase }),
);

export default getSelectedCityAddressUseCase;
